<template>
  <component-in-worker>
    <h2>Seccion en construccion</h2>
  </component-in-worker>
</template>

<script>
// test
import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "ListSLA",
  components: {
    ComponentInWorker
  }
};
</script>

<style></style>
